export class CookieKeyEnum {
    static DEVICE_OUTPUT = "deviceoutput";

    static AD_SPLASH = "ads";
}

export default CookieKeyEnum;
